import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  signOutBusy: boolean = true;  
  header: string = 'Signing Out...'
  constructor(private authService: AuthService) { }

  ngOnInit(): void {       
    this.authService.logout();
  }

}
